export default "__VITE_ASSET__1107b3b6__"